import layout from '../Layout';

function _enumerateSections() {
  let indexWrapper = document.getElementsByClassName('index-wrapper');

  if (!indexWrapper.length) {
    return;
  }

  indexWrapper = indexWrapper[0];

  const sections = indexWrapper.getElementsByClassName('shopify-section');
  let foundForward = false;
  let foundReverse = false;

  for (let i = 0; i < sections.length; i++) {
    const sectionForward = sections[i];
    const sectionReverse = sections[(sections.length - 1) - i];

    sectionForward.classList.remove('shopify-section-first');
    sectionReverse.classList.remove('shopify-section-last');

    if (!foundForward && sectionForward.offsetHeight) {
      foundForward = true;
      sectionForward.className += ' shopify-section-first';
    }

    if (!foundReverse && sectionReverse.offsetHeight) {
      foundReverse = true;
      sectionReverse.className += ' shopify-section-last';
    }
  }
}

export default function enumerateSections() {
  layout.onBreakpointChange(_enumerateSections);
  document.addEventListener('shopify:section:load', _enumerateSections);
  document.addEventListener('shopify:section:reorder', _enumerateSections);
  _enumerateSections();
}
